import { VendorInventoryCountPage } from "@/features/vendor-app/pages/VendorInventoryCountPage";
import { createFileRoute } from "@tanstack/react-router";

export type VendorInventoryCountSearch = {
	dateStart?: string;
	dateEnd?: string;
	branchID?: string;
	inventoryCountTransactionID?: string;
	search?: string;
	result?: string;
};

const str = (v: unknown): string | undefined =>
	typeof v === "string" && v !== "" ? v : undefined;

export const Route = createFileRoute("/vendor/inventory-count/")({
	// Filters live in the URL so they survive navigating to a product detail
	// page and back.
	validateSearch: (
		search: Record<string, unknown>,
	): VendorInventoryCountSearch => ({
		dateStart: str(search.dateStart),
		dateEnd: str(search.dateEnd),
		// Preserve "" (explicit "All Branches") distinct from undefined (unset).
		branchID: typeof search.branchID === "string" ? search.branchID : undefined,
		inventoryCountTransactionID: str(search.inventoryCountTransactionID),
		search: str(search.search),
		result: str(search.result) ?? "all",
	}),
	component: VendorInventoryCountPage,
});
